// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__nS3u-","fileBtn":"File_fileBtn__w-c5S","closeBtn":"File_closeBtn__1-_zt","fileSelected":"File_fileSelected__9mkMV","disabled":"File_disabled__EYsvI"};